/** Convert string[] → Tag[] for TagsField component */
export default function convertStringsToTags(tags: string[]): { label: string; value: string }[] {
  return tags.map((tag: string) => ({ label: tag, value: tag }));
}
